import OfferModal from '../OfferModal/offer-modal';

export default OfferModal;